import { render, staticRenderFns } from "./shuji.vue?vue&type=template&id=022b2dc9&"
import script from "./shuji.vue?vue&type=script&lang=js&"
export * from "./shuji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports